import {
  GET_SERTS_SUCCESS,
  GET_SERTS_FAIL,
  ADD_SERT_SUCCESS,
  ADD_SERT_FAIL,
  UPDATE_SERT_SUCCESS,
  UPDATE_SERT_FAIL,
  DELETE_SERT_SUCCESS,
  DELETE_SERT_FAIL,
  GET_SERT_PROFILE_SUCCESS,
  GET_SERT_PROFILE_FAIL,
  GET_CLASS_SUCCESS,
  GET_CLASS_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  mainClass: [],
  userProfile: {},
  class : [],
  error: {},
  loading: true
}

const serts = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SERTS_SUCCESS:
      return {
        ...state,
        mainClass: action.payload,
        loading: true
      }

      case GET_CLASS_SUCCESS:
        return {
          ...state,
          class: action.payload,
          loading: true
        }

    case GET_SERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

      case GET_CLASS_FAIL:
        return {
          ...state,
          error: action.payload,
        }

    case ADD_SERT_SUCCESS:

      return {
        ...state,
        mainClass: [action.payload, ...state.mainClass],
      }

    case ADD_SERT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SERT_PROFILE_SUCCESS:
      return {
        ...state,
        userProfile: action.payload,
      }

    case UPDATE_SERT_SUCCESS:
      return {
        ...state,
        mainClass: state.mainClass.map(user =>
          user.id.toString() === action.payload.id.toString()
            ? { user, ...action.payload }
            : user
        ),
      }

    case UPDATE_SERT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_SERT_SUCCESS:
      return {
        ...state,
        mainClass: state.mainClass.filter(
          user => user.id.toString() !== action.payload.toString()
        ),
      }

    case DELETE_SERT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SERT_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default serts
